export var getComponentStylesFromThemeFn = componentName => theme => {
  var {
    components: {
      [componentName]: componentStyles
    }
  } = theme;
  return componentStyles;
};
export var noop = () => null;